export default "__VITE_ASSET__Bx3SvZdf__"